export const iconFontAwesomeFilesFileShield = (
	<i className="fa-solid fa-file-shield"></i>
);
